import ChatVisualizationBarChart from './ChatVisualizationBarChart';
import ChatVisualizationLineChart from './ChatVisualizationLineChart';
import ChatVisualizationLoader from './ChatVisualizationLoader';
import ChatVisualizationTable from './ChatVisualizationTable';
import { ChatVisualization as ChatVisualizationPayload } from './visualizationTypes';

type ChatVisualizationProps = {
  visualization?: ChatVisualizationPayload;
  isLoading?: boolean;
};

export default function ChatVisualization({
  visualization,
  isLoading = false,
}: ChatVisualizationProps) {
  if (isLoading || !visualization) {
    return <ChatVisualizationLoader title={visualization?.title} />;
  }

  return (
    <div className="mt-3 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
      {visualization.title && (
        <div className="border-b border-gray-200 bg-gray-50 px-4 py-3 text-sm font-semibold text-grey-900">
          {visualization.title}
        </div>
      )}

      {visualization.type === 'table' && (
        <ChatVisualizationTable visualization={visualization} embedded />
      )}
      {visualization.type === 'bar_chart' && (
        <ChatVisualizationBarChart visualization={visualization} />
      )}
      {visualization.type === 'line_chart' && (
        <ChatVisualizationLineChart visualization={visualization} />
      )}
    </div>
  );
}
